import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, renderSlot as _renderSlot, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3baccf26"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "search-sort" }
const _hoisted_2 = { class: "sort-list" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "extra flex" }


import { t } from '@/plugins/i18n'

export default /*#__PURE__*/_defineComponent({
  props: ['label', 'value', 'options', 'startTop'],
  emits: ['update:value', 'change'],
  setup(__props, { emit }) {

const props = __props


console.log(props, 'props')

const cahngeVal = (v: any) => {
  emit('update:value', v.value)
  emit('change', v.value)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", {
      class: _normalizeClass(["label", __props.startTop ? 'startTop' : ''])
    }, _toDisplayString(__props.label ?? ''), 3),
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.options, (v) => {
        return (_openBlock(), _createElementBlock("div", {
          onClick: ($event: any) => (cahngeVal(v)),
          key: v.label,
          class: _normalizeClass([{ active: v.value === __props.value }, "sort-item"])
        }, _toDisplayString(_unref(t)(v.label)), 11, _hoisted_3))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_4, [
      _renderSlot(_ctx.$slots, "default")
    ])
  ]))
}
}

})